import React from "react";
import DSBox from "../../system-design/DSBox";
import DSTypography from "../../system-design/DSTypography";
import DSChip from "../../system-design/DSChip";

type CountrySectionHeaderProps = {
  countryName: string;
  eventCount: number;
  variant?: "h6" | "subtitle1";
};

const CountrySectionHeader = ({
  countryName,
  eventCount,
  variant = "subtitle1",
}: CountrySectionHeaderProps) => {
  return (
    <DSBox
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <DSTypography variant={variant} fontWeight="bold">
        {countryName}
      </DSTypography>
      <DSChip
        label={`${eventCount} event${eventCount > 1 ? "s" : ""}`}
        size="small"
        variant="outlined"
      />
    </DSBox>
  );
};

export default CountrySectionHeader;
